module.exports = __webpack_public_path__ + "img/hero-banner-1.8e4988f7.jpg";